export default __webpack_public_path__ + "static/CDR-Jan19-3627aa7955fded3e2fc6c090e46357ce.png";